import {Loader} from "./loader";

export const filters = {
    manufacturer: async (id) => {
        Loader.load()
        const urlSearchParams = new URLSearchParams(window.location.search);
        urlSearchParams.delete('filters[manufacturer]')
        let filters = urlSearchParams
        if (id) {
            filters = `filters[manufacturer]=${id}&${urlSearchParams}`
        }
        window.location.search = filters.toString()
        // const newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + filters.toString();
        // window.history.pushState({path:newUrl},'',newUrl);
        // api.get(`product/category&path=${path}&${filters}`).then(async (resp) => {
        //     const text = await resp.text()
        //     const myDiv = text.match(/<section class="tw-grid sm:tw-grid-cols-12 tw-gap-2 tw-items-start">(.*)<\/section >/sg)
        //     setTimeout(() => {
        //         document.getElementById('category_list').innerHTML = myDiv[0]
        //     }, 500)
        // })
    },
    price: async (value = '') => {
        Loader.load()

        const urlSearchParams = new URLSearchParams(window.location.search);
        urlSearchParams.delete('filters[price]')
        let filters = urlSearchParams
        if (value) {
            filters = `filters[price]=${value}&${urlSearchParams}`
        }

        window.location.search = filters.toString()
    },
    attribute: async (group, value = '') => {
        Loader.load()

        const urlSearchParams = new URLSearchParams(window.location.search);
        urlSearchParams.delete(`filters[${group}]`)

        let filters = urlSearchParams
        if (group && value) {
            filters = `filters[${group}]=${value}&${urlSearchParams}`
        }

        window.location.search = filters.toString()
    },
    range: () => {
        return {
            minprice: 1,
            maxprice: 191,
            min: 1,
            max: 191,
            minthumb: 0,
            maxthumb: 0,
            mintrigger() {
                this.minprice = Math.min(this.minprice, this.maxprice - 1);
                this.minthumb = ((this.minprice - this.min) / (this.max - this.min)) * 100;
            },
            maxtrigger() {
                this.maxprice = Math.max(this.maxprice, this.minprice + 10);
                this.maxthumb = 100 - (((this.maxprice - this.min) / (this.max - this.min)) * 100);
            },
        }
    },
    reset: (element) => {
        const el = document.getElementById(element)
        if (el.type === 'radio') {
            el.checked = false
            el.dispatchEvent(new Event('click'))
        } else {
            el.value = ''
            el.dispatchEvent(new Event('change'))
        }
    }
}